import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { client } from "helpers/client";
import DescriptionBox from "pages/details/components/description-box";
import { json } from "helpers/data";
import DetailList from "pages/details/components/detail-list";
import TagsList from "pages/details/components/tags-list";
import MediaGallery from "pages/details/components/media-gallery";
import ModuleHeader from "pages/details/components/module-header";

function ModuleDetailPage() {
  const moduleId = useParams().id;
  const { data } = useQuery<any>(["module-details", moduleId], () =>
    client(`/module/${moduleId}`).then((r) => r.response ?? {})
  );

  return (
    <div className="addonDetails">
      <ModuleHeader logo={data?.logo?.fullPath} title={data?.title ?? ""} />
      <div className="row">
        <div className="col-xl-6">
          <div className="all-content">
            <DescriptionBox content={json(data?.description ?? "")} />
            <DetailList
              items={data?.availableAppVersions ?? []}
              title="Available In These App Versions"
              labelField="title"
            />
            <TagsList tags={data?.tags ?? []} />
          </div>
        </div>
        <div className="col-xl-6">
          <MediaGallery
            images={
              data?.slidersPath.map((slider: string) => ({
                original: slider,
                thumbnail: slider,
              })) ?? []
            }
          />
        </div>
      </div>
    </div>
  );
}

export default ModuleDetailPage;
